import 'core-js/es6/map';
import 'core-js/es6/set';
import React from 'react';
import ReactDOM from 'react-dom';
import './polyfill';
// Import bootstrap styles first to avoid conflict with our styles
import 'bootstrap/dist/css/bootstrap.css';
// All stylesheets, in their original order, so lazy routes cannot reorder equal-specificity rules (see eager-css.js)
import './eager-css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { getReducers } from './reducers/reducers';
import {
  ConnectedRouter,
  routerMiddleware,
  routerReducer,
} from 'react-router-redux';
import SnackbarProvider from './components/shared/snackbar/SnackbarProvider';
import MiuThemeProvider from './theme/miu-theme-provider';
import { configureApi } from './services/api/api-configuration';
import AuthenticationStorage from './services/authentication-storage';
import history from './history';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers';

// Build the middleware for intercepting and dispatching navigation actions
const middleware = routerMiddleware(history);

const reducers = getReducers();

let initialState = {};

// Check user information in the local storage
const credentials = AuthenticationStorage.getCredentials();
const accounts = AuthenticationStorage.getAccounts();
if (credentials !== null) {
  initialState['auth'] = credentials;
  initialState['auth'].errors = [];
  initialState['auth'].loggedIn = true;
  initialState['auth'].accounts = accounts;
  initialState['theme'] = {
    theme: credentials.user && credentials.user.theme,
  };
}

// To debug redux store in Chrome DevTools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  combineReducers({
    ...reducers,
    router: routerReducer,
  }),
  initialState,
  composeEnhancers(applyMiddleware(middleware, thunk))
);

// Configure API layer
configureApi(store.dispatch, store.getState);

// React 18 on purpose keeps the legacy root. Measured on the real app: with createRoot, a render error that one of the route
// containers' error boundaries catches (e.g. /admin/project-locations with a project that has no location) is never
// committed, so the page stays on its loading state instead of showing the toast and redirecting; with this root it behaves
// as on React 17. The cause was not isolated; the app's react-redux 5, react-router 4 and react-bootstrap 0.32 all use
// legacy context. Moving to createRoot belongs with replacing those libraries (React 19 work, see docs/react-19-plan.md in the
// 360PLUS workspace).
ReactDOM.render(
  <Provider store={store}>
    <MiuThemeProvider>
      <SnackbarProvider>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <ConnectedRouter history={history}>
            <App />
          </ConnectedRouter>
        </LocalizationProvider>
      </SnackbarProvider>
    </MiuThemeProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/2vJdu84
serviceWorker.unregister();
